import React, { useContext, useEffect } from 'react';
import { Switch } from '@headlessui/react';
import { ShiftContext } from './ShiftProvider';


function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function Example() {

  const { setShift, shift } = useContext(ShiftContext);
  const day_shift = shift === 'day';
  useEffect(() => {
    localStorage.setItem('shiftStored', shift);
  }, [shift]);

  return (
    <Switch
      checked={shift}
      onChange={setShift}
      className={classNames(
        day_shift ? 'bg-indigo-400' : 'bg-indigo-600',
        'group relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 '
      )}
    >
      <span className="sr-only">Use setting</span>
      <div
        className={classNames(
          day_shift ? 'translate-x-5' : 'translate-x-0',
          'pointer-events-none relative inline-block h-5 w-5 rounded-full group bg-white shadow transform ring-0 transition ease-in-out duration-200'
        )}
      >
        <span
          className={classNames(
            day_shift ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200',
            'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity'
          )}
          aria-hidden="true"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
            <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
          </svg>
        </span>
        <span
          className={classNames(
            day_shift ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100',
            'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity'
          )}
          aria-hidden="true"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
            <path
              fillRule="evenodd"
              d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
              clipRule="evenodd"
            />
          </svg>
        </span>
      </div>
      <div className="z-999 absolute w-52 text-sm text-gray-200 uppercase m-2 mt-8 bg-black p-5 pt-2 pb-2 bg-opacity-70 hidden group-hover:block transition delay-75 -right-2">
        selected shift <span className="text-blue-500 font-bold"> {shift} </span>
      </div>
    </Switch>
  );
}
